module.exports = __webpack_public_path__ + "img/Lithuania.3707ff25.png";